import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useSelector } from 'react-redux';
import withMemo from '../../decorators/withMemo';
import PageTemplate from '../../templates/Page';
import { useHeader, useFooter } from '../../hooks/useAppLayout';
import PageSagas from './sagas';
import { selectors } from './redux';
var Page = function Page() {
  var data = useSelector(selectors.data);
  var isLoaded = useSelector(selectors.isLoaded);
  var headerProps = useHeader();
  var footerProps = useFooter();
  if (data === null || isLoaded === false) {
    return null;
  }
  var paragraphProps = {
    text: data.content
  };
  var pageTemplateProps = {
    headerProps: headerProps,
    footerProps: footerProps,
    paragraphProps: paragraphProps
  };
  return /*#__PURE__*/React.createElement(PageTemplate, pageTemplateProps);
};
Page.getInitialProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(ctx) {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", ctx.store.saga.run(PageSagas.init, ctx).toPromise());
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
Page.propTypes = {};
Page.defaultProps = {};
export default withMemo()(Page);